// The ground of a model land: a regular grid of heights (metres), read by the game (scene/modelLand.js, to draw the ground)
// and by the walking rules (scene/landWalk.js).
// Pure maths, no Three.js, so node can import it too.
//
// A terrain is { x0, z0, cell, nx, nz, h } — h holds nx*nz heights, row by row along x: CENTIMETRES (ints) by default, or — with hs / hb set —
// metres = hb + h * hs (e.g. Unity's Int16 heightmaps). Each grid square is two
// triangles split along the b–c diagonal (a=(i,j) b=(i+1,j) c=(i,j+1) d=(i+1,j+1)): abc and bdc. heightAt follows those triangles exactly.

export function makeTerrain(t) {
  const { x0, z0, cell, nx, nz } = t
  const hs = t.hs ?? 0.01, hb = t.hb ?? 0
  const H = (i, j) => hb + t.h[Math.max(0, Math.min(nz - 1, j)) * nx + Math.max(0, Math.min(nx - 1, i))] * hs
  let hMin = Infinity, hMax = -Infinity
  for (let k = 0; k < t.h.length; k++) { const v = t.h[k]; if (v < hMin) hMin = v; if (v > hMax) hMax = v }
  const heightAt = (x, z) => {
    const gx = (x - x0) / cell, gz = (z - z0) / cell
    const i = Math.floor(gx), j = Math.floor(gz), fx = gx - i, fz = gz - j
    const ha = H(i, j), hb = H(i + 1, j), hc = H(i, j + 1), hd = H(i + 1, j + 1)
    return fx + fz <= 1 ? ha + fx * (hb - ha) + fz * (hc - ha) : hd + (1 - fx) * (hc - hd) + (1 - fz) * (hb - hd)
  }
  // steepness (rise over run) around a point, measured a little wider than one square so single facets don't flicker
  const slopeAt = (x, z, e = cell * 0.75) => {
    const dx = (heightAt(x + e, z) - heightAt(x - e, z)) / (2 * e), dz = (heightAt(x, z + e) - heightAt(x, z - e)) / (2 * e)
    return Math.hypot(dx, dz)
  }
  return { ...t, heightAt, slopeAt, H, hMin: hb + hMin * hs, hMax: hb + hMax * hs }
}
